import Button from 'react-bootstrap/Button'
import Link from 'next/link'
import { pageRoutes } from 'constants/routing'
import BrandLogo from 'common/BrandLogo'

type ErrorComponentProps = {
  message?: string
}

const Error: React.FC<ErrorComponentProps> = ({ message = null }) => (
  <div className="h-100 flex-center">
    <div>
      <div className="fs-40 primary-text text-center">Oops!</div>
      <div className="fs-18 mb-5 danger-text">
        {message ?? 'The page you’re looking for was not found.'}
      </div>
      <div className="d-flex justify-content-center w-100">
        <BrandLogo width={300} height={150} className="align-self-center" />
      </div>
      <Link href={pageRoutes.PROVIDER_SEARCH} legacyBehavior>
        <Button block variant="info" className="py-3 fs-16">
          Back to Thriveworks
        </Button>
      </Link>
    </div>
  </div>
)

export default Error
